import { ErrorReasonEnum } from '@error/ENUM_ErrorReason';

export const isSignInCodeRejectedReason = (reason: string | null | undefined): boolean =>
  reason === ErrorReasonEnum.ClientSignInExpiredCode || reason === ErrorReasonEnum.ClientSignInInvalidCode;
